import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent, useCallback } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { SortableList, SortableListProps } from 'record-it-components/list/SortableList/SortableList';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { SortUtils } from 'record-it-utils/utils/SortUtils/SortUtils';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { TimeTrackingActivityListItem } from '../TimeTrackingActivityListItem/TimeTrackingActivityListItem';
export type TimeTrackingActivityListProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  timeTrackingActivities: Array<TimeTrackingActivity>;
};
export const TimeTrackingActivityList: FunctionComponent<TimeTrackingActivityListProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let timeTrackingActivities;
  if ($[2] !== t0) {
    ({
      timeTrackingActivities,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = timeTrackingActivities;
  } else {
    remainingProps = $[3];
    timeTrackingActivities = $[4];
  }
  const timeTrackingActivityRepository = useEntityRepository(EntityName.TimeTrackingActivity);
  const getItemKey = _temp;
  const renderItem = _temp2;
  let t1;
  if ($[5] !== timeTrackingActivities || $[6] !== timeTrackingActivityRepository) {
    t1 = t2 => {
      const {
        item: item_0,
        previousItem
      } = t2;
      const sortedActivities = SortUtils.sortIntoArrayAfterItem(timeTrackingActivities, item_0, previousItem);
      for (const [index, activity_0] of sortedActivities.entries()) {
        if (activity_0.order !== index) {
          timeTrackingActivityRepository.update({
            ...activity_0,
            order: index
          });
        }
      }
    };
    $[5] = timeTrackingActivities;
    $[6] = timeTrackingActivityRepository;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleItemSorted = useEventCallback(t1);
  let t2;
  if ($[8] !== handleItemSorted || $[9] !== timeTrackingActivities) {
    t2 = <SortableList items={timeTrackingActivities} renderItem={renderItem} getItemKey={getItemKey} onItemSorted={handleItemSorted} />;
    $[8] = handleItemSorted;
    $[9] = timeTrackingActivities;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== remainingProps || $[12] !== t2) {
    t3 = <div {...remainingProps}>{t2}</div>;
    $[11] = remainingProps;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
function _temp(activity) {
  return EntityUtils.getTrackingKey(activity);
}
function _temp2(t0) {
  const {
    item,
    ref,
    style
  } = t0;
  return <TimeTrackingActivityListItem ref={ref} timeTrackingActivity={item} style={style} data-testid="TimeTrackingActivityList.ListItem" />;
}